import { FormBase } from '@/libs/form/base'

export class Form extends FormBase {
    __type = 'form'

    constructor (configuration = {}) {
        super('root', configuration)
    }
}
